<template>
  <!-- 风险告知函上传 -->
  <div class="risk-letter">
    <div class="cont">
      <div class="tip error-tip">
        <!-- N-不需要回执 -->
        <template v-if="riskVisitPage === 'N'" >请在风险告知函每页骑缝处及最后页盖章处均加盖公章。<br/>风险提示【根据《‌中华人民共和国刑法》，伪造公司、企业、事业单位、人民团体的印章的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利，并处罚金。】</template>
        <template v-else>请在风险告知函回执页加盖公章。<br/>风险提示【根据《‌中华人民共和国刑法》，伪造公司、企业、事业单位、人民团体的印章的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利，并处罚金。】</template>
      </div>
      <div class="li">1.下载风险告知函模板</div>
      <div class="download" @click="downloadPDF"><img src="@/assets/image/nsale/downloadpdf.png" alt=""> 点击下载</div>
      <div class="li">2.上传风险告知函盖章件<span class="desc">(仅支持图片：jpg/png，5M以下)</span></div>
      <div>
        <input
          hidden
          ref="file"
          type="file"
          accept="image/*"
          @change="e=>imageChange(e)"
          multiple="multiple"
          id="riskLetter"
        />
        <!-- 上传图片区域 -->
        <div class="images">
          <div class="upload-item" @click="uploadImg" v-if="!riskStatus || riskStatus == '4'">
            <img src="@/assets/image/nsale/camera.png" alt="">
          </div>
          <div class="image-item" v-for="(img, i) in imgList" :key="i" @click="scale(img.url)">
            <img class="pic" :src="img.url" alt="">
            <img class="close" v-if="!riskStatus || riskStatus == '4'" src="@/assets/image/nsale/upload-close.png" @click="delImg(i)" alt="">
          </div>
        </div>

        <!-- 失败原因区域 -->
        <div class="error-tip" v-if="riskStatus == '4' && riskNotifyRemark">失败原因：{{ riskNotifyRemark }}</div>
      </div>
    </div>

    <div v-if="!riskStatus || (riskStatus==='4' && imgList.length)" class="submit-btn" @click="onSubmit">提交</div>
    <div v-if="riskStatus==='2'" class="submit-btn disable">系统审核失败，已提交人工审核</div>
    <div v-if="riskStatus==='4' && !imgList.length" class="submit-btn disable">审核失败，请重新上传</div>

    <div class="img-page" v-if="showScale">
      <p class="close" @click="showScale = false">
        X
      </p>
      <img :src="imgUrl" alt="" style="">
    </div>
  </div>
</template>
<script>
import apiNsale from "@/utils/nsaleApi.js"
import apiCps from "@/utils/cpsApi.js"

export default {
  data() {
    return {
      imgList: [],
      policyId: '',
      policyNo: '',
      riskVisitPage: null, // 1、未上传风险告知函 2、待回收风险告知函原件
      riskStatus: null, // null-未上传风险告知函，1-系统自动审核成功，2-系统审核失败转人工，3-人工审核成功，4-人工审核失败
      riskNotifyRemark: '', // 风险告知函审核不通过原因	
      imgUrl: '',
      showScale: false
    };
  },
  created(){
    const { id, no } = this.$route.query
    this.policyId = id
    this.policyNo = no
    this.getPolicyRiskNotify()
  },
  methods:{
    // 获取风险告知函内容
    getPolicyRiskNotify() {
      this.imgList = []
      apiNsale.getPolicyRiskNotify(this.policyNo)
        .then(res => res.data)
        .then(res => {
            if(res.returnCode === '0000') {
            this.riskStatus = res.content.riskStatus
            this.riskVisitPage = res.content.riskVisitPage
            this.riskNotifyRemark = res.content.riskNotifyRemark
            if(this.riskStatus && this.riskStatus != '4') {
              res.content.riskNotifyUrlList.forEach(d => {
                this.imgList.push({url: d})
              })
            } 
            }
        })
    },

    // 下载模板pdf
    downloadPDF() {
      const u = navigator.userAgent;
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      apiCps.createRiskReportPdf(this.policyId).then(res => {
        if(isIOS) {
          let blob = new Blob([res.data], {
            type: "application/octetstream;charset=utf-8",
          });
          let url = window.URL.createObjectURL(blob);
          let aLink = document.createElement("a");
          aLink.style.display = "none";
          aLink.href = url;
          aLink.setAttribute("download", "风险告知函模板.pdf");
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink);
          window.URL.revokeObjectURL(url);
        } else if(res.data) {
          window.open('/api_risk_cps/riskReport/createRiskReportPdf?policyId=' + this.policyId)
        }
      })
    },

    imageChange(e) {
      const files = e.target.files
      let name = files[0].name
      let type = name.substr(name.lastIndexOf('.'))
      if (type != '.jpg' && type != '.png') {
        this.$toast("选择上传的图片目前只支持.jpg和.png格式")
        return
      }
      if(files.length + this.imgList.length > 10) {
        this.$toast("最多可以上传十张图片")
        return
      }

      for (let i = 0; i < files.length; i++) {
        if(files[i].size/1024 > 5120) {
          this.$toast("上传文件大小超过5MB,请压缩后再试")
        } else {
          const _this = this
          const reader = new FileReader();
          reader.readAsDataURL(files[i])

          reader.onload = function(e) {
            _this.imgList.push({
              name: files[i].name,
              url: this.result,
              file: files[i]
            })
          }
        }
      }
    },

    delImg(i) {
      this.imgList.splice(i, 1)
    },

    uploadImg() {
      this.$refs.file.click()
    },

    // 提交风险告知书
    onSubmit() {
      if(!this.policyId) {
        this.$toast("保单号不存在")
        return
      }
      if(!this.imgList.length) {
        this.$toast("请先上传图片再完成提交")
        return
      }
      const filesObj = {}
      filesObj.length = this.imgList.length
      const fd = new FormData()
      for (let i = 0; i < this.imgList.length; i++) {
        filesObj[i] = this.imgList[i].file
        fd.append('files', this.imgList[i].file)
      }
      
      apiCps.ocrOfficialSeal(this.policyId, fd)
        .then(res => res.data)
        .then(res => {
          this.getPolicyRiskNotify()
        })
    },
    scale(imgUrl) {
      this.imgUrl = imgUrl
      this.showScale = true
    }
  }
}
</script>
<style lang="scss" scoped>
.risk-letter{
  overflow: hidden;
  border-top: 7px solid #F9F9F9;
  .cont{
    text-align: left;
    padding: 20px 20px 5px 20px;
    .li{
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #373737;
      font-weight: bold;
      margin-bottom: 14px;
    }
    .desc{
      font-size: 12px;
      color: #868686;
    }
    .download{
      font-family: PingFangSC-Medium;
      font-size: 13px;
      display: flex;
      align-items: center;
      width: 105px;
      color: #FF3600;
      padding: 8px 16px;
      border: 1px solid #FF3600;
      border-radius: 4px;
      text-align: center;
      margin-bottom: 18px;
      img{
        width: 14px;
        vertical-align: -1px;
        margin-right: 3px;
      }
    }
  }
  .submit-btn{
    font-size: 13px;
    position: fixed;
    bottom: 27px;
    left: calc(50% - 163px);
    width: 326px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    color: #fff;
    background: #FF3600;
    border-radius: 7px;
    &.disable{
      background: rgba(255, 54, 0, 0.38)
    }
  }

  .images{
    overflow: hidden;
    margin-top: 18px;
    .upload-item{
      float: left;
      text-align: center;
      background: #EFF0F1;
      border-radius: 6px;
      width: 70px;
      height: 70px;
      margin-right: 15px;
      margin-bottom: 15px;
      img{
        width: 18px;
        padding-top: 26px;
      }
    }
    .image-item{
      position: relative;
      float: left;
      width: 70px;
      height: 70px;
      border-radius: 6px;
      margin-right: 15px;
      margin-bottom: 15px;
      background: #EFF0F1;
      overflow: hidden;
      .pic{
        width: 100%;
        height: 100%;
      }
      .close{
        position: absolute;
        top: 3px;
        right: 3px;
        width: 12px;
      }
    }
  }

  .error-tip{
    font-size: 12px;
    color: #FF3600;
    line-height: 1.8;
  }
  .tip {
    font-weight: bold;
    margin-bottom: 12px;
  }
  .img-page {
    width: 100%;
    height: 100vh;
    background: #000;
    position: fixed;
    top:0;
    left:0;
    overflow: auto;
    img {
      position: absolute;
      top: 10%;
      left:0;
      width: 100%;
    }
    .close {
      text-align: right;
    margin: 20px;
    color: #fff;
    font-weight: 600;
    font-size: 20px;
    }
  }
}
</style>